module.exports = __webpack_public_path__ + "img/portfolio-details1.55dcaa65.png";